module.exports = __webpack_public_path__ + "files/32e285cae504e2e23089232f689476ad.svg";